import React, { useEffect, useState } from "react";
import { Page } from "../../../../components";
import { useSelector } from "react-redux";
// import { NotiOptions } from "./NotiOpitons";
import { PayOptions } from "./PayOpitons";
import { KisPg, ThanksQR } from "./PgKeys";
import { debug } from "../../../../settings";

export default function PaymentSetting(props) {
  const { shopInfo } = useSelector(state => state.shop);

  const pgs = {
    kisPg: "KISPG",
    // tQr: "THANKSQR"
  }

  // 
  // TQR은 유니온포스만 우선 지원
  // 
  if(shopInfo.posName==="UNIONPOS") {
    pgs.tQr = "THANKSQR"
  }

  const pgNameList = Object.keys(pgs).map(key => pgs[key])
  const [pgName2, setPgName2] = useState(pgs.kisPg)

  useEffect(() => {
    if (shopInfo.payOptions?.pgName) {
      if(debug) {
        console.log('payOptions', shopInfo.payOptions)
        console.log(pgs, pgNameList)
      }
      setPgName2(shopInfo.payOptions?.pgName)
    }
  }, [shopInfo])

  const pageProps = { ...props, shopInfo, pgNameList, pgName2, setPgName2 }

  return (
    <Page>
      <PayOptions {...pageProps} />
      <br />

      {pgName2 === pgs.tQr && <ThanksQR {...pageProps} />}

      {pgName2 === pgs.kisPg && <KisPg {...pageProps} />}
    </Page>
  );
}
